import SEO from "@components/seo"
import { pageUrl } from "@config"
import {
  createPath,
  createUserYearPath,
  parseData,
  parseGameData,
} from "@src/components/page/lib"
import Pages from "@src/components/pages/index/pages"
import Preparing from "@src/components/prepare"
import AppContext from "@src/context/appContext"
import { requestCurrentUser, requestGapi } from "@src/utils/request"
import { wxConfig, wxShare } from "@src/utils/wechat"
import MobileDetect from "mobile-detect"
import React, { useEffect, useState } from "react"
import url from "url"

// import * as styles from "./index.module.scss"

const IndexPage = () => {
  const [data, setData] = useState()
  const [isMobile, setIsMobile] = useState()
  const [isWXBrowser, setIsWXBrowser] = useState(false)
  const [md, setMd] = useState()
  const [queryToken, setQueryToken] = useState()
  const [currentUser, setCurrentUser] = useState()

  const loaded = data?.loaded
  const needSignin = data === "needSignin"
  const loading = data === undefined

  const pageUrlWithToken = data?.token
    ? `${pageUrl}?token=${data.token}`
    : undefined

  console.log("data", data)

  const request = async (path, options) => {
    const res = await requestGapi(path).catch((e) => {
      console.log("网络数据请求错误：", e)
      return null
    })
    const parsed = parseData(res, options)
    if (!parsed) {
      setData(null)
      return
    }
    console.log("parsed.user", parsed.user)
    setData(parsed)
    if (!parsed.user) {
      setData(parsed)
      return
    }
    const userId = parsed.user.id
    // const userId = "31343" // test
    const gameRes = await requestGapi(
      createPath(`users/${userId}`, {
        include: "entities.involvements.entry.involvements.entity.user",
      })
    )
    const gameData = parseGameData(gameRes)
    setData({
      ...parsed,
      gameData,
    })
  }

  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  useEffect(() => {
    const md = new MobileDetect(window.navigator.userAgent)
    const mobile = !!md.mobile()
    setMd(md)
    setIsWXBrowser(
      /micromessenger/.test(window.navigator.userAgent.toLowerCase())
    )
    setIsMobile(mobile)
    if (!mobile) {
      document.documentElement.classList.add("is_desktop")
    } else {
      document.documentElement.classList.add("is_mobile")
      // ios safari 的导航条会挡住底部
      setTimeout(() => {
        const viewH = window.innerHeight // 浏览器的视窗高度
        const pageH = window.document.documentElement.offsetHeight // 页面高度
        if (pageH > viewH) {
          // 以便 css 那边做缩放，将导航条的部分流出来
          document.documentElement.style.setProperty(
            "--scale-for-safari",
            viewH / pageH
          )
        }
      }, 300)
    }
  }, [])

  useEffect(() => {
    const token = url.parse(window.location.href, true)?.query?.token
    const path = createUserYearPath({
      "filter[year]": 2021,
      ...(token && { "filter[token]": token }),
    })
    if (!token) {
      requestCurrentUser().then((user) => {
        setCurrentUser(user)
        if (!user) {
          setData("needSignin")
          return
        }
        request(path, { myself: true })
      })
    } else {
      setQueryToken(token)
      request(path, { myself: false })
    }
  }, [])

  useEffect(() => {
    if (pageUrlWithToken) {
      wxShare({
        link: pageUrlWithToken,
      })
    }
  }, [pageUrlWithToken])

  return (
    <>
      <Preparing
        data={data}
        needSignin={needSignin}
        loading={loading}
        loaded={loaded}
        isMobile={isMobile}
      />
      <SEO />
      <AppContext.Provider
        value={{
          data,
          pageUrl,
          pageUrlWithToken,
          isMobile,
          isWXBrowser,
          currentUser,
          queryToken,
          md,
        }}
      >
        {!needSignin && <Pages data={data} isMobile={isMobile} />}
      </AppContext.Provider>
    </>
  )
}

export default IndexPage
